export default "__VITE_ASSET__DNPo6apF__"